import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { getFilterValues } from '../sbSharedRefineMenuHelpers';

// components
import { SbSharedRefineMenuMultiSelect } from '../SbSharedRefineMenuMultiSelect/SbSharedRefineMenuMultiSelect';
import { SbSharedRefineMenuExpandableItemList } from '../SbSharedRefineMenuExpandableItemList/SbSharedRefineMenuExpandableItemList';

/* eslint-disable react/prop-types, react/display-name */

export const SbSharedRefineMenuMultiSelectListComponent = props => {
    const { values, itemSearch, filterName, collapsedItemCount } = props;
    const { appliedFilters } = itemSearch;

    const appliedFilterValues = getFilterValues(appliedFilters, filterName);

    return (
        <SbSharedRefineMenuExpandableItemList
            filterName={filterName}
            availableFilterValues={values}
            collapsedItemCount={collapsedItemCount}
        >
            {({ valuesToShow }) => (
                <SbSharedRefineMenuMultiSelect
                    filterName={filterName}
                    appliedFilterValues={appliedFilterValues}
                    valuesToShow={valuesToShow}
                />
            )}
        </SbSharedRefineMenuExpandableItemList>
    );
};

SbSharedRefineMenuMultiSelectListComponent.propTypes = {
    values: PropTypes.array.isRequired,
    collapsedItemCount: PropTypes.number,
    filterName: PropTypes.string.isRequired,
    itemSearch: PropTypes.object.isRequired,
};

export const SbSharedRefineMenuMultiSelectList = createFragmentContainer(
    SbSharedRefineMenuMultiSelectListComponent,
    {
        itemSearch: graphql`
            fragment SbSharedRefineMenuMultiSelectList_itemSearch on ItemSearchQueryConnection {
                appliedFilters {
                    name
                    localizedFilterName
                    canBeDismissed
                    values {
                        urlLabel
                        count
                        displayName
                    }
                }
            }
        `,
    }
);
